<template>
  <div>
    
  </div>
</template>

<script>
import router from '../router'
import firebase from '../Firebase'
import { mapActions, mapState, mapGetters } from "vuex"
export default {
  name: 'Landing',
  data() {
    return {
        user_type: this.$route.query.user_type,
        session_id: this.$route.query.session_id,
        page: this.$route.query.page,
        token: this.$route.query.token,
    }
  },
  props: {
    msg: String
  },
  computed: {
    ...mapGetters({
      userType: "user/getUserType",
      userId: "user/getUserId",
    }),
  },
  methods: {
    ...mapActions({
      setUserType: "user/setUserType",
      setUserId: "user/setUserId",
    }),
    setLoginUserType: async function(item) {
      this.setUserType(item)
    },
    setLoginUserId: async function(item) {
      this.setUserId(item)
    },
    async siginWithToken(token) {
      return new Promise((resolve, reject) => {
        firebase.auth().signInWithCustomToken(token).then((userCredential) => {
          const user = userCredential.user;
          resolve(userCredential.user.uid)
        })
        .catch((error) => {
          const errorCode = error.code;
          const errorMessage = error.message;
          console.log(error)
          resolve(null)
        })
      })
    },
  },
  async created() {
    const chatToken = this.$cookies .get('chatToken')
    // alert(chatToken)
    if(chatToken != null){
      const uid = await this.siginWithToken(chatToken)
      if(uid != null){
        this.setLoginUserType(this.user_type)
        this.setLoginUserId(uid)
        console.log(uid, this.user_type, this.token)
        if(this.page == 'chat')
          router.push(`/chat/`+this.session_id) 
        else if(this.page == 'main')
          router.push(`/main`) 
      }else{
        router.push(`/error`) 
      }
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
